/**
 * Base API
 * API for Base Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ImageConfigEntry { 
    type?: ImageConfigEntry.TypeEnum;
    element?: ImageConfigEntry.ElementEnum;
    sizeType?: ImageConfigEntry.SizeTypeEnum;
    languages?: Array<string>;
}
export namespace ImageConfigEntry {
    export type TypeEnum = 'START_PAGE_IMAGE' | 'APP_LOGO';
    export const TypeEnum = {
        STARTPAGEIMAGE: 'START_PAGE_IMAGE' as TypeEnum,
        APPLOGO: 'APP_LOGO' as TypeEnum
    };
    export type ElementEnum = 'START_PAGE_IMAGE_DE_DEFAULT' | 'START_PAGE_IMAGE_FR_DEFAULT' | 'START_PAGE_IMAGE_AG' | 'START_PAGE_IMAGE_BE' | 'APP_LOGO_DEFAULT' | 'APP_LOGO_BE' | 'APP_LOGO_BS';
    export const ElementEnum = {
        STARTPAGEIMAGEDEDEFAULT: 'START_PAGE_IMAGE_DE_DEFAULT' as ElementEnum,
        STARTPAGEIMAGEFRDEFAULT: 'START_PAGE_IMAGE_FR_DEFAULT' as ElementEnum,
        STARTPAGEIMAGEAG: 'START_PAGE_IMAGE_AG' as ElementEnum,
        STARTPAGEIMAGEBE: 'START_PAGE_IMAGE_BE' as ElementEnum,
        APPLOGODEFAULT: 'APP_LOGO_DEFAULT' as ElementEnum,
        APPLOGOBE: 'APP_LOGO_BE' as ElementEnum,
        APPLOGOBS: 'APP_LOGO_BS' as ElementEnum
    };
    export type SizeTypeEnum = 'SMALL' | 'DEFAULT' | 'LARGE';
    export const SizeTypeEnum = {
        SMALL: 'SMALL' as SizeTypeEnum,
        DEFAULT: 'DEFAULT' as SizeTypeEnum,
        LARGE: 'LARGE' as SizeTypeEnum
    };
}


